import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "54",
  height: "34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.945 33.72a.975.975 0 0 1-.712-1.639l1.865-2-2-1.865a.974.974 0 0 1 1.327-1.427l2.716 2.531a.975.975 0 0 1 .048 1.377l-2.529 2.715a.97.97 0 0 1-.713.31M29.619 31.033a.974.974 0 0 1-.042-1.947c12.077-.531 21.9-4.588 21.9-9.043 0-1.973-1.921-3.572-3.533-4.566a.974.974 0 0 1 1.023-1.658c2.917 1.8 4.458 3.95 4.458 6.224 0 5.762-9.994 10.383-23.764 10.989h-.044",
  fill: "#000"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M23.542 31.02H23.5C9.881 30.363 0 25.747 0 20.042c0-2.273 1.542-4.425 4.458-6.224a.974.974 0 1 1 1.023 1.658c-1.612.994-3.533 2.593-3.533 4.566 0 4.48 9.506 8.447 21.64 9.031a.974.974 0 0 1-.046 1.947M21.828 19.322V1.369a.782.782 0 0 1 1.244-.633l12.317 8.977a.783.783 0 0 1 0 1.265l-12.317 8.977a.783.783 0 0 1-1.244-.633",
  fill: "#000"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }